import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getInitialPhotoCropbox } from '../helpers';
import WatermarkOverlay from '../../../../../components/global/WatermarkOverlay';

const propTypes = {
  className: PropTypes.string,
  cropbox: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    scale: PropTypes.number.isRequired,
    rotation: PropTypes.number.isRequired,
  }),
  src: PropTypes.string.isRequired,
  isEntitled: PropTypes.bool,
  isForegroundImage: PropTypes.bool,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const CardElementPhotoImage = ({
  className,
  cropbox,
  src,
  isEntitled = true,
  isForegroundImage = false,
  watermarkSettings,
}) => {
  const classes = classNames({
    'card-element-photo-contain': true,
    [className]: !!className,
  });

  const { x, y, scale, rotation } = cropbox ?? getInitialPhotoCropbox();

  return (
    <div className={classes}>
      <div
        className="card-element-photo-translate"
        style={{
          transform: `translate(${x * 100}%, ${y * 100}%) scale(${scale})`,
        }}
      >
        <div
          className="card-element-photo-image"
          style={{
            transform: `rotate(${rotation}rad)`,
            backgroundImage: `url(${src})`,
          }}
        />
      </div>
      {!isEntitled && !isForegroundImage && (
        <div className="watermark-container">
          <WatermarkOverlay
            text={watermarkSettings?.wallpaperCustomText}
            fontSize={watermarkSettings?.wallpaperFontSize}
            wallpaperMode={watermarkSettings?.wallpaperWatermarkMode}
            imageUrl={watermarkSettings?.wallpaperAssetImage?.url}
          />
        </div>
      )}
    </div>
  );
};

CardElementPhotoImage.propTypes = propTypes;

export default CardElementPhotoImage;
